import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { ScreenLoader } from '@equinor/opt-ui-core';
import Header from 'AppLayout/Header';
import { links } from 'Utils/routes/constants';
const LandingPage = lazy(() => import('./appModules/Landing'));
const ProtectedRoutes = lazy(() => import('./ProtectedRoutes'));
const AppRootComponent = () => (React.createElement(MsalAuthenticationTemplate, { interactionType: InteractionType.Redirect },
    React.createElement(Header, null),
    React.createElement("div", { className: "app-content" },
        React.createElement(Suspense, { fallback: React.createElement(ScreenLoader, null) },
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/", element: React.createElement(LandingPage, null) }),
                links.map(({ href, component: Component }) => {
                    if (!Component)
                        return null;
                    return React.createElement(Route, { key: href, path: href, element: React.createElement(Component, null) });
                }),
                React.createElement(Route, { path: "/auth.html", element: React.createElement(Navigate, { to: "/", replace: true }) }),
                React.createElement(Route, { path: "*", element: React.createElement(ProtectedRoutes, null) }))))));
export default AppRootComponent;
